import { Transform } from 'class-transformer';
import {
	IsInt,
	IsMimeType,
	IsNotEmpty,
	IsOptional,
	IsString,
	IsUUID,
	Matches,
	Max,
	MaxLength,
	Min,
} from 'class-validator';
import sanitize from 'sanitize-filename';

const sanitizeName = ({ value }: { value: unknown }) =>
	typeof value === 'string' ? sanitize(value.trim()) : null;

export const COURSES_LESSON_FILE_MAX_BYTES = 50 * 1024 * 1024;

export class CoursesUploadUrlDto {
	@Transform(sanitizeName)
	@IsNotEmpty()
	@IsString()
	@MaxLength(200)
	name: string;

	@IsMimeType()
	mimeType: string;
}

export class CoursesBannerConfirmDto {
	@IsUUID()
	fileId: string;
}

export class CoursesLessonFileUploadUrlDto extends CoursesUploadUrlDto {
	@IsInt()
	@Min(1)
	@Max(COURSES_LESSON_FILE_MAX_BYTES)
	size: number;

	@IsOptional()
	@Matches(/^[0-9a-f]{64}$/)
	sha256?: string;
}

export class CoursesLessonFileConfirmDto {
	@IsUUID()
	fileId: string;

	@IsOptional()
	@Transform(sanitizeName)
	@IsString()
	@MaxLength(200)
	filename?: string;

	@IsOptional()
	@IsString()
	@MaxLength(200)
	chapter_label?: string;
}
